import { Directive, Input } from '@angular/core';
import { ImmomioIconName } from '../../models';

@Directive()
export abstract class ErrorInfoBaseComponent {
  @Input() text?: string;
  @Input() maxLines?: number = 2;
  public immomioIconName = ImmomioIconName;
}
